import { render } from "./PrintPage2.vue?vue&type=template&id=151d62c6&scoped=true"
import script from "./PrintPage2.vue?vue&type=script&lang=js"
export * from "./PrintPage2.vue?vue&type=script&lang=js"

import "./PrintPage2.vue?vue&type=style&index=0&id=151d62c6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-151d62c6"]])

export default __exports__